import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useProjectMapContext } from './../hooks/useProjectMapContext';
import { useDispatch, useSelector } from 'react-redux';
import { debug, download, swalAlert } from './../../../utils';
import API from './../../../api';
import { HtmlElement } from './../../helpers/HtmlElements/HtmlElements';
import InputAutocomplete from './../../helpers/InputAutocomplete/InputAutocomplete';
import LayerSelector from '../helpers/LayerSelector';
import { useTranslation } from 'react-i18next';
import './modal-project-export.css';
const ModalProjectExport = ({ show, handleClose = null }) => {
  const user = useSelector((state) => state.user);
  const project = useSelector((state) => state.project);
  const { t } = useTranslation();
  const {
    userCan,
  } = useProjectMapContext();
  const [params, setParams] = useState({
    entity: "project",
    id: project.projId,
    type: "table",
    type: "sheet",
    data: "physiologie",
    scope: "project",
    pictures: "one_row",
    layerId: '',
    itemId: ''
  });
  const [response, setResponse] = useState({})
  const [fetching, setFetching] = useState(false);
  const typeOptions = [
    { value: "table", label: "Tableau (xls)" },
    { value: "sheet", label: "Fiche (pdf)" }
  ];
  const dataOptions = [
    { value: "dendrometrie", label: "Dendrométrie" },
    { value: "physiologie", label: "Physiologie" },
    { value: "mecanique", label: "Mécanique" },
    { value: "taches", label: "Tâches" }
  ]
  const scopeOptions = [
    { value: "project", label: "Tout le projet" },
    { value: "layer", label: "Un calque" }
  ];
  const photosOptions = [
    { value: "none", label: "Aucune" },
    { value: "one", label: "Une (la première)" },
    { value: "one_row", label: "Une rangée en bas de page (2,3 ou 4)" },
    { value: "all", label: "Toutes (Plusieurs pages)" }
  ];
  const itemsOptions = project.items
    .filter(it => it.itType === 'tree')
    .sort((a, b) => {
      const regex = /^(\D*)(\d*)$/; // Capture le texte et le nombre séparément
      const [, textA, numA] = a.itRef.match(regex);
      const [, textB, numB] = b.itRef.match(regex);
      // Comparaison d'abord sur la partie texte
      if (textA !== textB) {
        return textA.localeCompare(textB); // Tri alphabétique
      }
      // Puis comparaison numérique sur la partie chiffre
      return (Number(numA) || 0) - (Number(numB) || 0);
    })
    .map(it => ({ value: it.itId, label: (it.itRef ? 'N°' + it.itRef : 'sans ref') + (it.meta.essence_fr ? ' - ' + it.meta.essence_fr : '') }));
  useEffect(() => { setResponse({}) }, [params])
  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    const paramsCopy = { ...params, [name]: type == 'checkbox' ? checked : value };
    if (name === 'layerId') {
      // paramsCopy.scope = value !== '' ? 'layer' : 'project';
      paramsCopy.scope = 'layer';
    }
    if (name === 'itemId') {
      paramsCopy.scope = 'item';
    }
    setParams(paramsCopy);
  };
  const handleClick = async () => {
    if (params.scope === 'layer' && params.layerId == '') {
      swalAlert("veuillez sélectionner un calque.")
      return;
    }
    if (params.scope === 'item' && params.itemId == '') {
      swalAlert("veuillez sélectionner un sujet.")
      return;
    }
    setFetching(true);
    setResponse();
    try {
      const response = await API.post(`/export`, { ...params });
      setResponse(response.data)
    } catch (error) {
      swalAlert(t(error.response.data.error.message));
    } finally {
      setFetching(false);
    }
  };
  const handleSuggestionSelect = (data) => {
    console.log(data)
  }
  return (
    (userCan('editParams')) &&
    <Modal show={show} size='lg' onHide={handleClose} id="ModalProjectExport">
      <Modal.Header closeButton>
        <Modal.Title>
          Export du projet "{project?.projName}"
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={fetching ? 'fetching' : ''}>
        <div className="form-group">
          <label className="form-group-label">Type d'export :</label>
          <div className="d-flex" style={{ gap: '15px' }}>
            {typeOptions.map((option) => (
              <HtmlElement.radio
                key={option.value}
                onChange={handleChange}
                name="type"
                checked={params.type == option.value}
                value={option.value}
                label={option.label}
              />
            ))}
          </div>
        </div>
        <div className="form-group">
          <label className="form-group-label">Données à exporter :</label>
          <div className="d-flex" style={{ gap: '15px' }}>
            {dataOptions.map((option) => (
              <HtmlElement.radio
                key={option.value}
                onChange={handleChange}
                name="data"
                checked={params.data == option.value}
                value={option.value}
                label={option.label}
              />
            ))}
          </div>
        </div>
        <div className="form-group">
          <label className="form-group-label">Portée :</label>
          <div className="d-flex" style={{ gap: '15px' }}>
            <HtmlElement.radio
              key='project'
              onChange={handleChange}
              name="scope"
              checked={params.scope == 'project'}
              value='project'
              label='Tout le projet'
            />
            <div className='d-flex'>
              <HtmlElement.radio
                key='layer'
                wrapperClasssName='me-1'
                onChange={handleChange}
                name="scope"
                className='short'
                checked={params.scope == 'layer'}
                value='layer'
                label=''
              />
              <LayerSelector
                name="layerId"
                selectedId={params.layerId}
                label={false}
                allowCreate={false}
                onChange={handleChange}
              />
            </div>
            {params.type == 'sheet' &&
              <div className='d-flex'>
                <HtmlElement.radio
                  key='item'
                  wrapperClasssName='me-1'
                  onChange={handleChange}
                  name="scope"
                  className='short'
                  checked={params.scope == 'item'}
                  value='item'
                  label=''
                />



                <HtmlElement.select
                  style={{ maxWidth: '240px' }}
                  onChange={handleChange}
                  name="itemId"
                  options={[{ value: '', label: 'Selectionner un sujet' }, ...itemsOptions]}
                />
              </div>
            }
          </div>
        </div>
        {params.type == 'sheet' &&
          <div className="form-group">
            <label className="form-group-label">Photos :</label>
            <div className="d-flex" style={{ gap: '15px' }}>
              <HtmlElement.select
                style={{ maxWidth: '240px' }}
                onChange={handleChange}
                name="pictures"
                options={photosOptions}
              />
            </div>
          </div>
        }
        <div className="mb-4"></div>
        <div className="form-group">
          <div className=''>
            <button
              className="me-5 btn btn-sm btn-primary"
              onClick={handleClick}
              disabled={fetching || params.scope == 'layer'}
            >Exporter</button>
            {response && response.output_file &&
              <button className="me-5 btn btn-sm btn-outline-primary" onClick={e => download(`/utils/file?path=${response.output_file}`)} >
                Télécharger le fichier
                {params.type === 'table' ? ' Excel' : ' PDF'}
              </button>
            }
            {(params.scope == 'layer') && <span className='me-5'>
              En cours de développement
            </span>}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex">
        <div className="w-100 d-flex">
          <div className="text-start w-50">
            {debug(params)}
          </div>
          <div className="text-start w-50">
            {debug(response)}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalProjectExport;
